import styled from 'styled-components';
import { colours, media } from '@storefront/lib-global/stylings';

export const ProductFeatureWrapper = styled.li`
  flex: 1 1 975px;
  list-style: none;

  @media ${media.greaterThan('lg')} {
    flex: 1 1 215px;
  }
`;

export const ProductFeatureLink = styled.div`
  a {
    color: ${colours.BLACK};
    text-decoration: none;
  }
`;

export const Link = styled.div`
  &[role='link'] {
    cursor: pointer;
  }
`;
